/**
 * Garde de sortie — registre minimal, hors React.
 *
 * L'app tourne sous <BrowserRouter> (pas de routeur « data ») : `useBlocker`
 * n'existe pas. Une page qui a quelque chose à perdre (ex. la vidéo du récap
 * pas encore partagée) pose ici une fonction ; les liens de navigation
 * globaux (BottomNavBar) la consultent avant de naviguer.
 *
 * Contrat :
 *  - `setLeaveGuard(fn)` : une seule garde à la fois ; `fn()` renvoie un
 *    booléen ou une promesse de booléen (true = on peut partir). Renvoie une
 *    fonction de retrait qui n'efface que sa propre garde.
 *  - `setLeaveGuard(null)` : retire la garde courante.
 *  - `getLeaveGuard()` : la garde courante ou null. Sans garde, les liens
 *    naviguent comme avant, sans rien attendre.
 *
 * Un module plutôt qu'un contexte : poser ou retirer la garde ne doit
 * re-rendre personne (ni MainLayout, ni la barre du bas).
 *
 * Limite connue : le retour système (bouton retour Android, glissé iOS) ne
 * passe pas par ici et ne peut pas être bloqué proprement avec BrowserRouter.
 */
let current = null;

export const setLeaveGuard = (fn) => {
  current = typeof fn === 'function' ? fn : null;
  const mine = current;
  return () => {
    if (current === mine) current = null;
  };
};

export const getLeaveGuard = () => current;

/** Demande à la garde si l'on peut partir ; sans garde, oui tout de suite. */
export const confirmLeave = async () => {
  const guard = current;
  if (!guard) return true;
  try {
    return !!(await guard());
  } catch {
    return false;
  }
};
